export default "__VITE_ASSET__vxbz6tEx__"